import React from 'react';
export const VideoContext = React.createContext({ setProps: () => { } });
